// Leitura de um item de estoque pro card: custo que a ficha usa, texto do
// saldo e barra min→max. Mesmas convencoes de products/cmv.py e da baixa
// (pedidos/stock.py::fator_estoque).
import { compraDe, usoDe } from "@/features/estoque-unidade/lib/unidade";

export const fmtQtd = (v, unit) => {
  const n = Number(v) || 0;
  if ((unit || "").toLowerCase() === "un" && Math.abs(n - Math.round(n)) < 1e-9) return String(Math.round(n));
  const t = n.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
  return (t || "0").replace(".", ",");
};
export const fmtBRL = (v) => `R$ ${(Number(v) || 0).toFixed(2).replace(".", ",")}`;

const forma = (ing) => ({ unit: ing.unit || "", unitsPerPackage: String(ing.units_per_package || ""), unitWeight: String(ing.unit_weight || "") });

/** "compra un · ficha kg" + detalhe (caixa de N / 1 un = X kg). */
export function unidadeResumo(ing) {
  const f = forma(ing);
  const compra = compraDe(f) || (ing.unit === "kg" ? "kg" : "un");
  const uso = usoDe(f) || (compra === "kg" ? "kg" : "un");
  const rot = { kg: "kg", un: "un", caixa: "caixa" };
  const detalhe = compra === "caixa" ? `caixa de ${fmtQtd(ing.units_per_package, "un")} un`
    : Number(ing.unit_weight) > 0 ? `1 un = ${fmtQtd(ing.unit_weight, "kg")} kg` : "";
  return { compra: rot[compra], uso, detalhe, mesma: rot[compra] === uso };
}

/** Custo de 1 unidade DA FICHA, ja com a perda, e a conta em uma linha. */
export function custoFicha(ing) {
  const avg = Number(ing.average_price) || 0;
  if (avg <= 0) return null;
  const uw = Number(ing.unit_weight) || 0;
  const pkg = Number(ing.units_per_package) || 0;
  const loss = Number(ing.loss_percent) || 0;
  const lossF = loss > 0 && loss < 100 ? 1 / (1 - loss / 100) : 1;
  const u = (ing.unit || "").toLowerCase();
  const partes = [];
  let base, unidade;
  if (pkg > 0) { base = avg; unidade = "un"; partes.push(`${fmtBRL(avg)}/un`, `caixa de ${pkg} = ${fmtBRL(avg * pkg)}`); }
  else if (u === "kg" && uw > 0) { base = avg * uw; unidade = "un"; partes.push(`${fmtBRL(avg)}/kg`, `1 un = ${fmtQtd(uw, "kg")} kg`); }
  else if (u === "un" && uw > 0) { base = avg / uw; unidade = "kg"; partes.push(`${fmtBRL(avg)}/un`, `1 un = ${fmtQtd(uw, "kg")} kg`); }
  else { base = avg; unidade = u || "un"; partes.push(`${fmtBRL(avg)}/${unidade}`); }
  if (loss > 0) partes.push(`perda ${loss.toFixed(loss % 1 ? 2 : 0).replace(".", ",")}%`);
  return { valor: base * lossF, unidade, conta: partes.join(" · "), temPerda: loss > 0 };
}

/** Saldo na unidade do estoque + equivalencia na outra unidade. */
export function saldoTexto(ing) {
  const qty = Number(ing.stock_quantity) || 0;
  const uw = Number(ing.unit_weight) || 0;
  const pkg = Number(ing.units_per_package) || 0;
  const u = (ing.unit || "un").toLowerCase();
  let secundario = "";
  if (pkg > 0) secundario = `= ${fmtQtd(qty / pkg, "kg")} caixa${qty / pkg === 1 ? "" : "s"}`;
  else if (u === "kg" && uw > 0) secundario = `= ${fmtQtd(qty / uw, "un")} un`;
  else if (u === "un" && uw > 0) secundario = `= ${fmtQtd(qty * uw, "kg")} kg`;
  return { principal: `${fmtQtd(qty, u)} ${u}`, secundario };
}

/** Barra min→max: progresso 0-100 e se ha faixa definida. */
export function barraEstoque(ing) {
  const qty = Number(ing.stock_quantity) || 0, min = Number(ing.stock_min) || 0, max = Number(ing.stock_max) || 0;
  if (max <= 0 && min <= 0) return { temFaixa: false, progresso: 0 };
  const teto = max > 0 ? max : min * 2;
  return { temFaixa: true, progresso: Math.min(100, Math.max(0, (qty / teto) * 100)), marcaMin: min > 0 && teto > 0 ? Math.min(100, (min / teto) * 100) : null };
}
